/* tslint:disable */
import { Observable } from 'rxjs';
import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import {
  BaseApiClient,
  RequestContext,
  ApiConfigManager,
  HttpRequestState
} from '@sg/api/base-api-lib';
import { BroadcastApiConfig } from '../api-config';

import { BroadcastApi } from '../models';

@Injectable()
export class BroadcastRecipientApiClient extends BaseApiClient<BroadcastApiConfig> {
  constructor(httpClient: HttpClient, config: ApiConfigManager) {
    super(httpClient, config.broadcastApiConfig);
  }

  recipientControllerCreateRecipient(
    body?:
      | BroadcastApi.DirectEmailRecipientCreateDto
      | BroadcastApi.DirectFtpRecipientCreateDto
      | BroadcastApi.ConnectionStringFtpRecipientCreateDto
      | BroadcastApi.DirectHttpRecipientCreateDto
      | BroadcastApi.ConnectionStringHttpRecipientCreateDto,

    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<
    | BroadcastApi.DirectEmailRecipient
    | BroadcastApi.DirectFtpRecipient
    | BroadcastApi.ConnectionStringFtpRecipient
    | BroadcastApi.DirectHttpRecipient
    | BroadcastApi.ConnectionStringHttpRecipient
  >;
  recipientControllerCreateRecipient(
    body?:
      | BroadcastApi.DirectEmailRecipientCreateDto
      | BroadcastApi.DirectFtpRecipientCreateDto
      | BroadcastApi.ConnectionStringFtpRecipientCreateDto
      | BroadcastApi.DirectHttpRecipientCreateDto
      | BroadcastApi.ConnectionStringHttpRecipientCreateDto,

    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<
    HttpResponse<
      | BroadcastApi.DirectEmailRecipient
      | BroadcastApi.DirectFtpRecipient
      | BroadcastApi.ConnectionStringFtpRecipient
      | BroadcastApi.DirectHttpRecipient
      | BroadcastApi.ConnectionStringHttpRecipient
    >
  >;
  recipientControllerCreateRecipient(
    body?:
      | BroadcastApi.DirectEmailRecipientCreateDto
      | BroadcastApi.DirectFtpRecipientCreateDto
      | BroadcastApi.ConnectionStringFtpRecipientCreateDto
      | BroadcastApi.DirectHttpRecipientCreateDto
      | BroadcastApi.ConnectionStringHttpRecipientCreateDto,

    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<
    | BroadcastApi.DirectEmailRecipient
    | BroadcastApi.DirectFtpRecipient
    | BroadcastApi.ConnectionStringFtpRecipient
    | BroadcastApi.DirectHttpRecipient
    | BroadcastApi.ConnectionStringHttpRecipient
  >;
  recipientControllerCreateRecipient(
    body?:
      | BroadcastApi.DirectEmailRecipientCreateDto
      | BroadcastApi.DirectFtpRecipientCreateDto
      | BroadcastApi.ConnectionStringFtpRecipientCreateDto
      | BroadcastApi.DirectHttpRecipientCreateDto
      | BroadcastApi.ConnectionStringHttpRecipientCreateDto,

    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<
    HttpRequestState<
      | BroadcastApi.DirectEmailRecipient
      | BroadcastApi.DirectFtpRecipient
      | BroadcastApi.ConnectionStringFtpRecipient
      | BroadcastApi.DirectHttpRecipient
      | BroadcastApi.ConnectionStringHttpRecipient
    >
  >;
  recipientControllerCreateRecipient(
    body?:
      | BroadcastApi.DirectEmailRecipientCreateDto
      | BroadcastApi.DirectFtpRecipientCreateDto
      | BroadcastApi.ConnectionStringFtpRecipientCreateDto
      | BroadcastApi.DirectHttpRecipientCreateDto
      | BroadcastApi.ConnectionStringHttpRecipientCreateDto,

    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<
    HttpResponse<
      | BroadcastApi.DirectEmailRecipient
      | BroadcastApi.DirectFtpRecipient
      | BroadcastApi.ConnectionStringFtpRecipient
      | BroadcastApi.DirectHttpRecipient
      | BroadcastApi.ConnectionStringHttpRecipient
    >
  >;
  recipientControllerCreateRecipient(
    body?:
      | BroadcastApi.DirectEmailRecipientCreateDto
      | BroadcastApi.DirectFtpRecipientCreateDto
      | BroadcastApi.ConnectionStringFtpRecipientCreateDto
      | BroadcastApi.DirectHttpRecipientCreateDto
      | BroadcastApi.ConnectionStringHttpRecipientCreateDto,

    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<
    HttpEvent<
      | BroadcastApi.DirectEmailRecipient
      | BroadcastApi.DirectFtpRecipient
      | BroadcastApi.ConnectionStringFtpRecipient
      | BroadcastApi.DirectHttpRecipient
      | BroadcastApi.ConnectionStringHttpRecipient
    >
  >;
  recipientControllerCreateRecipient(
    body?:
      | BroadcastApi.DirectEmailRecipientCreateDto
      | BroadcastApi.DirectFtpRecipientCreateDto
      | BroadcastApi.ConnectionStringFtpRecipientCreateDto
      | BroadcastApi.DirectHttpRecipientCreateDto
      | BroadcastApi.ConnectionStringHttpRecipientCreateDto,

    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<
      | BroadcastApi.DirectEmailRecipient
      | BroadcastApi.DirectFtpRecipient
      | BroadcastApi.ConnectionStringFtpRecipient
      | BroadcastApi.DirectHttpRecipient
      | BroadcastApi.ConnectionStringHttpRecipient
    >(`${this.basePath}/gateway/admin/broadcast/recipient`, body, <any>Object.assign(baseOptions, {}));

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  recipientControllerUpdateRecipient(
    params: {
      body?:
        | BroadcastApi.DirectEmailRecipientCreateDto
        | BroadcastApi.DirectFtpRecipientCreateDto
        | BroadcastApi.ConnectionStringFtpRecipientCreateDto
        | BroadcastApi.DirectHttpRecipientCreateDto
        | BroadcastApi.ConnectionStringHttpRecipientCreateDto;
      id: string;
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<
    | BroadcastApi.DirectEmailRecipient
    | BroadcastApi.DirectFtpRecipient
    | BroadcastApi.ConnectionStringFtpRecipient
    | BroadcastApi.DirectHttpRecipient
    | BroadcastApi.ConnectionStringHttpRecipient
  >;
  recipientControllerUpdateRecipient(
    params: {
      body?:
        | BroadcastApi.DirectEmailRecipientCreateDto
        | BroadcastApi.DirectFtpRecipientCreateDto
        | BroadcastApi.ConnectionStringFtpRecipientCreateDto
        | BroadcastApi.DirectHttpRecipientCreateDto
        | BroadcastApi.ConnectionStringHttpRecipientCreateDto;
      id: string;
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<
    HttpResponse<
      | BroadcastApi.DirectEmailRecipient
      | BroadcastApi.DirectFtpRecipient
      | BroadcastApi.ConnectionStringFtpRecipient
      | BroadcastApi.DirectHttpRecipient
      | BroadcastApi.ConnectionStringHttpRecipient
    >
  >;
  recipientControllerUpdateRecipient(
    params: {
      body?:
        | BroadcastApi.DirectEmailRecipientCreateDto
        | BroadcastApi.DirectFtpRecipientCreateDto
        | BroadcastApi.ConnectionStringFtpRecipientCreateDto
        | BroadcastApi.DirectHttpRecipientCreateDto
        | BroadcastApi.ConnectionStringHttpRecipientCreateDto;
      id: string;
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<
    | BroadcastApi.DirectEmailRecipient
    | BroadcastApi.DirectFtpRecipient
    | BroadcastApi.ConnectionStringFtpRecipient
    | BroadcastApi.DirectHttpRecipient
    | BroadcastApi.ConnectionStringHttpRecipient
  >;
  recipientControllerUpdateRecipient(
    params: {
      body?:
        | BroadcastApi.DirectEmailRecipientCreateDto
        | BroadcastApi.DirectFtpRecipientCreateDto
        | BroadcastApi.ConnectionStringFtpRecipientCreateDto
        | BroadcastApi.DirectHttpRecipientCreateDto
        | BroadcastApi.ConnectionStringHttpRecipientCreateDto;
      id: string;
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<
    HttpRequestState<
      | BroadcastApi.DirectEmailRecipient
      | BroadcastApi.DirectFtpRecipient
      | BroadcastApi.ConnectionStringFtpRecipient
      | BroadcastApi.DirectHttpRecipient
      | BroadcastApi.ConnectionStringHttpRecipient
    >
  >;
  recipientControllerUpdateRecipient(
    params: {
      body?:
        | BroadcastApi.DirectEmailRecipientCreateDto
        | BroadcastApi.DirectFtpRecipientCreateDto
        | BroadcastApi.ConnectionStringFtpRecipientCreateDto
        | BroadcastApi.DirectHttpRecipientCreateDto
        | BroadcastApi.ConnectionStringHttpRecipientCreateDto;
      id: string;
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<
    HttpResponse<
      | BroadcastApi.DirectEmailRecipient
      | BroadcastApi.DirectFtpRecipient
      | BroadcastApi.ConnectionStringFtpRecipient
      | BroadcastApi.DirectHttpRecipient
      | BroadcastApi.ConnectionStringHttpRecipient
    >
  >;
  recipientControllerUpdateRecipient(
    params: {
      body?:
        | BroadcastApi.DirectEmailRecipientCreateDto
        | BroadcastApi.DirectFtpRecipientCreateDto
        | BroadcastApi.ConnectionStringFtpRecipientCreateDto
        | BroadcastApi.DirectHttpRecipientCreateDto
        | BroadcastApi.ConnectionStringHttpRecipientCreateDto;
      id: string;
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<
    HttpEvent<
      | BroadcastApi.DirectEmailRecipient
      | BroadcastApi.DirectFtpRecipient
      | BroadcastApi.ConnectionStringFtpRecipient
      | BroadcastApi.DirectHttpRecipient
      | BroadcastApi.ConnectionStringHttpRecipient
    >
  >;
  recipientControllerUpdateRecipient(
    params: {
      body?:
        | BroadcastApi.DirectEmailRecipientCreateDto
        | BroadcastApi.DirectFtpRecipientCreateDto
        | BroadcastApi.ConnectionStringFtpRecipientCreateDto
        | BroadcastApi.DirectHttpRecipientCreateDto
        | BroadcastApi.ConnectionStringHttpRecipientCreateDto;
      id: string;
    },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.put<
      | BroadcastApi.DirectEmailRecipient
      | BroadcastApi.DirectFtpRecipient
      | BroadcastApi.ConnectionStringFtpRecipient
      | BroadcastApi.DirectHttpRecipient
      | BroadcastApi.ConnectionStringHttpRecipient
    >(
      `${this.basePath}/gateway/admin/broadcast/recipient/${this.encodeURI(String(params.id))}`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  recipientControllerGetRecipientById(
    id: string,

    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<
    | BroadcastApi.DirectEmailRecipient
    | BroadcastApi.DirectFtpRecipient
    | BroadcastApi.ConnectionStringFtpRecipient
    | BroadcastApi.DirectHttpRecipient
    | BroadcastApi.ConnectionStringHttpRecipient
  >;
  recipientControllerGetRecipientById(
    id: string,

    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<
    HttpResponse<
      | BroadcastApi.DirectEmailRecipient
      | BroadcastApi.DirectFtpRecipient
      | BroadcastApi.ConnectionStringFtpRecipient
      | BroadcastApi.DirectHttpRecipient
      | BroadcastApi.ConnectionStringHttpRecipient
    >
  >;
  recipientControllerGetRecipientById(
    id: string,

    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<
    | BroadcastApi.DirectEmailRecipient
    | BroadcastApi.DirectFtpRecipient
    | BroadcastApi.ConnectionStringFtpRecipient
    | BroadcastApi.DirectHttpRecipient
    | BroadcastApi.ConnectionStringHttpRecipient
  >;
  recipientControllerGetRecipientById(
    id: string,

    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<
    HttpRequestState<
      | BroadcastApi.DirectEmailRecipient
      | BroadcastApi.DirectFtpRecipient
      | BroadcastApi.ConnectionStringFtpRecipient
      | BroadcastApi.DirectHttpRecipient
      | BroadcastApi.ConnectionStringHttpRecipient
    >
  >;
  recipientControllerGetRecipientById(
    id: string,

    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<
    HttpResponse<
      | BroadcastApi.DirectEmailRecipient
      | BroadcastApi.DirectFtpRecipient
      | BroadcastApi.ConnectionStringFtpRecipient
      | BroadcastApi.DirectHttpRecipient
      | BroadcastApi.ConnectionStringHttpRecipient
    >
  >;
  recipientControllerGetRecipientById(
    id: string,

    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<
    HttpEvent<
      | BroadcastApi.DirectEmailRecipient
      | BroadcastApi.DirectFtpRecipient
      | BroadcastApi.ConnectionStringFtpRecipient
      | BroadcastApi.DirectHttpRecipient
      | BroadcastApi.ConnectionStringHttpRecipient
    >
  >;
  recipientControllerGetRecipientById(
    id: string,

    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', id]);

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<
      | BroadcastApi.DirectEmailRecipient
      | BroadcastApi.DirectFtpRecipient
      | BroadcastApi.ConnectionStringFtpRecipient
      | BroadcastApi.DirectHttpRecipient
      | BroadcastApi.ConnectionStringHttpRecipient
    >(
      `${this.basePath}/gateway/admin/broadcast/recipient/${this.encodeURI(String(id))}`,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  recipientControllerSearchRecipients(
    params: {
      body: BroadcastApi.RecipientSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'name' | 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<BroadcastApi.RecipientSearchResponse>;
  recipientControllerSearchRecipients(
    params: {
      body: BroadcastApi.RecipientSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'name' | 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<BroadcastApi.RecipientSearchResponse>>;
  recipientControllerSearchRecipients(
    params: {
      body: BroadcastApi.RecipientSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'name' | 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<BroadcastApi.RecipientSearchResponse>;
  recipientControllerSearchRecipients(
    params: {
      body: BroadcastApi.RecipientSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'name' | 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<BroadcastApi.RecipientSearchResponse>>;
  recipientControllerSearchRecipients(
    params: {
      body: BroadcastApi.RecipientSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'name' | 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<BroadcastApi.RecipientSearchResponse>>;
  recipientControllerSearchRecipients(
    params: {
      body: BroadcastApi.RecipientSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'name' | 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<BroadcastApi.RecipientSearchResponse>>;
  recipientControllerSearchRecipients(
    params: {
      body: BroadcastApi.RecipientSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'name' | 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body]);

    const consumes = ['application/json'];

    requestContext.queryParams = this.createQueryParams(
      ['', 'pageSize', params.pageSize],
      ['', 'pageNumber', params.pageNumber],
      ['', 'order', params.order],
      ['', 'orderBy', params.orderBy],
      ['', 'sortDirection', params.sortDirection]
    );

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<BroadcastApi.RecipientSearchResponse>(
      `${this.basePath}/gateway/admin/broadcast/recipient/search`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  recipientControllerGetValidRecipientTypes(options?: {
    observe?: 'bodyPromise';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Promise<
    Array<
      | 'DirectEmailRecipient'
      | 'ConnectionStringFtpRecipient'
      | 'DirectFtpRecipient'
      | 'ConnectionStringHttpRecipient'
      | 'DirectHttpRecipient'
    >
  >;
  recipientControllerGetValidRecipientTypes(options?: {
    observe: 'responsePromise';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Promise<
    HttpResponse<
      Array<
        | 'DirectEmailRecipient'
        | 'ConnectionStringFtpRecipient'
        | 'DirectFtpRecipient'
        | 'ConnectionStringHttpRecipient'
        | 'DirectHttpRecipient'
      >
    >
  >;
  recipientControllerGetValidRecipientTypes(options?: {
    observe: 'body';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Observable<
    Array<
      | 'DirectEmailRecipient'
      | 'ConnectionStringFtpRecipient'
      | 'DirectFtpRecipient'
      | 'ConnectionStringHttpRecipient'
      | 'DirectHttpRecipient'
    >
  >;
  recipientControllerGetValidRecipientTypes(options?: {
    observe: 'bodyWithState';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Observable<
    HttpRequestState<
      Array<
        | 'DirectEmailRecipient'
        | 'ConnectionStringFtpRecipient'
        | 'DirectFtpRecipient'
        | 'ConnectionStringHttpRecipient'
        | 'DirectHttpRecipient'
      >
    >
  >;
  recipientControllerGetValidRecipientTypes(options?: {
    observe: 'response';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Observable<
    HttpResponse<
      Array<
        | 'DirectEmailRecipient'
        | 'ConnectionStringFtpRecipient'
        | 'DirectFtpRecipient'
        | 'ConnectionStringHttpRecipient'
        | 'DirectHttpRecipient'
      >
    >
  >;
  recipientControllerGetValidRecipientTypes(options?: {
    observe: 'events';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Observable<
    HttpEvent<
      Array<
        | 'DirectEmailRecipient'
        | 'ConnectionStringFtpRecipient'
        | 'DirectFtpRecipient'
        | 'ConnectionStringHttpRecipient'
        | 'DirectHttpRecipient'
      >
    >
  >;
  recipientControllerGetValidRecipientTypes(
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<
      Array<
        | 'DirectEmailRecipient'
        | 'ConnectionStringFtpRecipient'
        | 'DirectFtpRecipient'
        | 'ConnectionStringHttpRecipient'
        | 'DirectHttpRecipient'
      >
    >(`${this.basePath}/gateway/admin/broadcast/recipient/types`, <any>Object.assign(baseOptions, {}));

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }
}
